import request from '@/utils/request'

// 物资分类

export const materialCategoryCount = (data = {}) => request({ url: `/api/estate/v1/oa/materialCategoryCount`, method: 'post', data })

export const materialCategoryIns = (data = {}) => request({ url: `/api/estate/v1/oa/materialCategoryIns`, method: 'post', data })

export const materialCategoryUpd = (data = {}) => request({ url: `/api/estate/v1/oa/materialCategoryUpd`, method: 'post', data })

export const materialCategoryDel = (data = {}) => request({ url: `/api/estate/v1/oa/materialCategoryDel`, method: 'post', data })

export const materialCategoryDelBatch = (data = {}) => request({ url: `/api/estate/v1/oa/materialCategoryDelBatch`, method: 'post', data })

export const materialCategoryCustomPage = (data = {}) => request({ url: `/api/estate/v1/oa/materialCategoryCustomPage`, method: 'post', data })

// 仓库设置
export const warehouseCount = (data = {}) => request({ url: `/api/estate/v1/oa/warehouseCount`, method: 'post', data })

export const warehouseIns = (data = {}) => request({ url: `/api/estate/v1/oa/warehouseIns`, method: 'post', data })

export const warehouseUpd = (data = {}) => request({ url: `/api/estate/v1/oa/warehouseUpd`, method: 'post', data })

export const warehouseDel = (data = {}) => request({ url: `/api/estate/v1/oa/warehouseDel`, method: 'post', data })

export const warehouseDelBatch = (data = {}) => request({ url: `/api/estate/v1/oa/warehouseDelBatch`, method: 'post', data })

export const warehouseCustomInsert = (data = {}) => request({ url: `/api/estate/v1/oa/warehouseCustomInsert`, method: 'post', data })

export const warehousePage = (data = {}) => request({ url: `/api/estate/v1/oa/warehousePage  `, method: 'post', data })

// 物资列表
export const materialPage = (data = {}) => request({ url: `/api/estate/v1/oa/materialPage`, method: 'post', data })

export const materialCount = (data = {}) => request({ url: `/api/estate/v1/oa/materialCount`, method: 'post', data })

export const materialIns = (data = {}) => request({ url: `/api/estate/v1/oa/materialIns`, method: 'post', data })

export const materialUpd = (data = {}) => request({ url: `/api/estate/v1/oa/materialUpd`, method: 'post', data })

export const materialDel = (data = {}) => request({ url: `/api/estate/v1/oa/materialDel`, method: 'post', data })

export const materialDelBatch = (data = {}) => request({ url: `/api/estate/v1/oa/materialDelBatch`, method: 'post', data })

// 出入库
export const materialStockRecordCount = (data = {}) => request({ url: `/api/estate/v1/oa/materialStockRecordCount`, method: 'post', data })

export const materialStockRecordPage = (data = {}) => request({ url: `/api/estate/v1/oa/materialStockRecordPage`, method: 'post', data })

// 物资库存
export const materialStockCount = (data = {}) => request({ url: `/api/estate/v1/oa/materialStockCount`, method: 'post', data })

export const materialStockPage = (data = {}) => request({ url: `/api/estate/v1/oa/materialStockPage`, method: 'post', data })

export const materialInIns = (data = {}) => request({ url: `/api/estate/v1/oa/materialInIns`, method: 'post', data })

export const materialStockUpd = (data = {}) => request({ url: `/api/estate/v1/oa/materialStockUpd`, method: 'post', data })

export const doMaterialStock = (data = {}) => request({ url: `/api/estate/v1/oa/doMaterialStock`, method: 'post', data })

export const doMaterialAllocation = (data = {}) => request({ url: `/api/estate/v1/oa/doMaterialAllocation`, method: 'post', data })

export const materialStockCustomPage = (data = {}) => request({ url: `/api/estate/v1/oa/materialStockCustomPage`, method: 'post', data })

export const materialStockDetail = (data = {}) => request({ url: `/api/estate/v1/oa/materialStockDetail`, method: 'post', data })

export const materialStockDelete = (data = {}) => request({ url: `/api/estate/v1/oa/materialStockDelete`, method: 'post', data })

export const materialStockDeleteBatch = (data = {}) => request({ url: `/api/estate/v1/oa/materialStockDeleteBatch`, method: 'post', data })

// 物资申领
export const flowApplyMateriallInfo = (data = {}) => request({ url: `/api/estate/v1/workflow/materialApplyDetail`, method: 'post', data })

export const materialApplyPage = (data = {}) => request({ url: `/api/estate/v1/workflow/flowMaterialDetailList`, method: 'post', data })

export const materialApplyCount = (data = {}) => request({ url: `/api/estate/v1/workflow/flowMaterialDetailCount`, method: 'post', data })

// 物资借用
export const flowBorrowMaterialPage = (data = {}) => request({ url: `/api/estate/v1/workflow/flowBorrowMaterialPage`, method: 'post', data })

export const flowBorrowMaterialCount = (data = {}) => request({ url: `/api/estate/v1/workflow/flowBorrowMaterialCount`, method: 'post', data })

export const flowBorrowMaterialInfo = (data = {}) => request({ url: `/api/estate/v1/workflow/flowBorrowMaterialInfo`, method: 'post', data })

export const materialBorrow = (data = {}) => request({ url: `/api/estate/v1/oa/materialBorrow`, method: 'post', data })

export const materialInPage = (data = {}) => request({ url: `/api/estate/v1/oa/materialInPage`, method: 'post', data })

export const materialInCount = (data = {}) => request({ url: `/api/estate/v1/oa/materialInCount`, method: 'post', data })

export const materialInDetail = (data = {}) => request({ url: `/api/estate/v1/oa/materialInDetail`, method: 'post', data })

export const confirmIn = (data = {}) => request({ url: `/api/estate/v1/oa/confirmIn`, method: 'post', data })

export const materialOutIns = (data = {}) => request({ url: `/api/estate/v1/oa/materialOutIns`, method: 'post', data })

export const materialInventoryIns = (data = {}) => request({ url: `/api/estate/v1/oa/materialInventoryIns`, method: 'post', data })

export const materialOutPage = (data = {}) => request({ url: `/api/estate/v1/oa/materialOutPage`, method: 'post', data })

export const materialOutCount = (data = {}) => request({ url: `/api/estate/v1/oa/materialOutCount`, method: 'post', data })

export const materialOutDetail = (data = {}) => request({ url: `/api/estate/v1/oa/materialOutDetail`, method: 'post', data })

export const confirmOut = (data = {}) => request({ url: `/api/estate/v1/oa/confirmOut`, method: 'post', data })

export const materialAllotPage = (data = {}) => request({ url: `/api/estate/v1/oa/materialAllotPage`, method: 'post', data })

export const materialAllotCount = (data = {}) => request({ url: `/api/estate/v1/oa/materialAllotCount`, method: 'post', data })

export const materialInventoryPage = (data = {}) => request({ url: `/api/estate/v1/oa/materialInventoryPage`, method: 'post', data })

export const materialInventoryCount = (data = {}) => request({ url: `/api/estate/v1/oa/materialInventoryCount`, method: 'post', data })

export const materialInventoryDetail = (data = {}) => request({ url: `/api/estate/v1/oa/materialInventoryDetail`, method: 'post', data })

export const materialAllotIns = (data = {}) => request({ url: `/api/estate/v1/oa/materialAllotIns`, method: 'post', data })

export const materialAllotDetail = (data = {}) => request({ url: `/api/estate/v1/oa/materialAllotDetail`, method: 'post', data })

export const submitFlowPurchaseApply = (data = {}) => request({ url: `/api/estate/v1/workflow/submitFlowPurchaseApply`, method: 'post', data })

export const materialPurchasePage = (data = {}) => request({ url: `/api/estate/v1/oa/materialPurchasePage`, method: 'post', data })

export const materialPurchaseCount = (data = {}) => request({ url: `/api/estate/v1/oa/materialPurchaseCount`, method: 'post', data })

export const flowApplyPurchaseInfo = (data = {}) => request({ url: `/api/estate/v1/workflow/flowApplyPurchaseInfo`, method: 'post', data })

export const materialPurchasePlanPage = (data = {}) => request({ url: `/api/estate/v1/oa/materialPurchasePlanPage`, method: 'post', data })

export const materialPurchasePlanCount = (data = {}) => request({ url: `/api/estate/v1/oa/materialPurchasePlanCount`, method: 'post', data })

export const completedPurchase = (data = {}) => request({ url: `/api/estate/v1/oa/completedPurchase`, method: 'post', data })

export const warehouseMaterialRelPage = (data = {}) => request({ url: `/api/estate/v1/oa/warehouseMaterialRelPage`, method: 'post', data })

export const warehouseMaterialRelCount = (data = {}) => request({ url: `/api/estate/v1/oa/warehouseMaterialRelCount`, method: 'post', data })

export const warehouseMaterialRelUpd = (data = {}) => request({ url: `/api/estate/v1/oa/warehouseMaterialRelUpd`, method: 'post', data })

export const materialBudgetByWarehouseId = (data = {}) => request({ url: `/api/estate/v1/oa/materialBudgetByWarehouseId`, method: 'post', data })
